export default {
  noData: 'No New Task',
  headerTitle: 'Task Center',
  limitData: 'Display only the first 50 tasks within the last 14 days.',
  jobStatus: {
    pending: 'Waiting for Processing',
    running: 'Generating',
    success: 'Success',
    failed: 'Failure',
    partSuccess: 'Partially Successful',
    stopped: 'Stop',
  },
  jobType: {
    vrecRecording: 'Screen Recording Export',
    veRender: 'Video Export',
    VeSimple: 'Video Templates',
    aigcTask: 'AI Video Generate',
    aiBanner: 'URL to Image',
    avatarVideo: 'Avatar to Video',
    gmPush: 'Playable Variant Application',
    dmDown: 'Customize Playable Download',
    dmPush: 'Customize Playable Application',
    aiRemove: 'AI Removal',
    subtitles: 'Subtitle Recognition',
  },
  title: 'Playable Variant Download',
}
